import { Component, OnInit, ElementRef, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { NgForm, FormBuilder } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ViewTableComponent } from '../../base/view-table/view-table.component';
import { PrintService } from '../../../services/print.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { UtilityService } from 'src/app/services/utility.service';
import { FieldsService } from 'src/app/services/fields.service';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { RefreshService } from 'src/app/services/refresh.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { TranslateService } from '@ngx-translate/core';
import { StudentDashboardWrapperComponent } from '../../student/student-dashboard-wrapper/student-dashboard-wrapper.component';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-lessons-list-report',
  templateUrl: './lessons-list-report.component.html',
  styleUrls: ['./lessons-list-report.component.css']
})
export class LessonsListReportComponent extends ViewTableComponent implements OnInit {
  StudentDashboardWrapperComponent = StudentDashboardWrapperComponent;

  enrollmentFilter: boolean | null = null;

  // Per-status facet counts from the list response, keyed by bundle then tid.
  // Fed to the grouped status filter so each status shows how many rows it
  // matches under the current (non-status) filters.
  statusCounts: { [bundle: string]: { [tid: string]: number } } = {};

  constructor(
    private _printService: PrintService,
    public override _refreshService: RefreshService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService
  ) {
    super(
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService
    );
  }
  override displayedColumns: string[] = [
    'id',
    // 'title',
    'field_status',
    'nothing_1',
    // 'field_instructor',
    'view_user',
    'views_conditional_field',
    'title_1',
    'field_email',
    'field_date_and_time_value',
    'views_conditional_field_1',
    'field_date_and_time_1',
    'field_expiration_date_1',
    'field_duration',
    'created',
    'field_type',
    // 'field_repetition_frequency',
    // 'field_type_1',
    // 'field_category',
    // 'edit_events',
    // 'views_conditional_field_2',
    'event_actions',
  ];

  override ngOnInit() {
    // Initialize pagination values
    this.paginationIndex = 0;
    this.pageSize = 10;  // Set default page size

    // Call parent ngOnInit if it exists
    super.ngOnInit();

    // Don't call getData here - let the parent ngOnInit handle the route subscription
    // which will call getData through the route params subscription
  }

  exportLessonListReport() {
    let exportParams = this.prepareExportParams(this.queryParams);
    LoggerService.log('Export params:', exportParams); // For debugging
    this.downloadCSVDrupalViews('/api/v1/appointment-list/export', 'appointment_list', exportParams);
  }

  private prepareExportParams(params: { parameter: string; value: string; }[]): { parameter: string; value: string; }[] {
    let exportParams = [...params]; // Create a copy of the params

    // Ensure type_event_entity_type is set to 'All'
    this.addOrUpdateParam(exportParams, 'type_event_entity_type', 'All');

    // Ensure instructor is set to an empty string if not already set
    if (!exportParams.find(p => p.parameter === 'instructor')) {
      this.addOrUpdateParam(exportParams, 'instructor', '');
    }

    // Handle enrollment filter
    const enrollmentParamIndex = exportParams.findIndex(p => p.parameter === 'id_op_enrollment');
    if (this.enrollmentFilter === true) {
      this.updateQueryParam(enrollmentParamIndex, 'empty', exportParams);
    } else if (this.enrollmentFilter === false) {
      this.updateQueryParam(enrollmentParamIndex, 'not+empty', exportParams);
    } else {
      // Remove the parameter for the undefined state
      if (enrollmentParamIndex !== -1) {
        exportParams.splice(enrollmentParamIndex, 1);
      }
    }

    return exportParams;
  }

  private addOrUpdateParam(params: { parameter: string; value: string; }[], parameter: string, value: string) {
    const index = params.findIndex(p => p.parameter === parameter);
    if (index !== -1) {
      params[index].value = value;
    } else {
      params.push({ parameter, value });
    }
  }

  private updateQueryParam(index: number, value: string, params: { parameter: string; value: string; }[]) {
    const param = { parameter: 'id_op_enrollment', value: value };
    if (index === -1) {
      params.push(param);
    } else {
      params[index] = param;
    }
  }

  override getData(params: { parameter: string; value: string; }[]) {
    // Store only non-pagination params in queryParams
    this.queryParams = params.filter(param =>
      param.parameter !== 'page' && param.parameter !== 'items_per_page'
    );

    this.ShowProgressBar = true;

    // Add current pagination state to params if not present
    let finalParams = [...params];
    if (!params.some(p => p.parameter === 'page')) {
      finalParams.push(
        { parameter: 'page', value: this.paginationIndex.toString() },
        { parameter: 'items_per_page', value: this.pageSize.toString() }
      );
    }

    finalParams = this.buildRequestParams(finalParams);

    // Load the new data with the filtering parameters.
    this._utilityService.getLessonListReport(
      finalParams
    )
      .subscribe((data) => {
        // ShowProgressBar
        this.ShowProgressBar = false;

        this.data = data;
        this.dataSource = new MatTableDataSource(data['results']);

        // Facet counts for the grouped status filter (present only when a date
        // range is set; otherwise the backend returns empty groups).
        this.statusCounts = data['status_counts'] || {};

        // Pagination
        if (data['results']) {
          this.setupPagination(data, params);
        }

        // Post process the data.
        this.decorateRows(this.data['results']);
      },
      error => this.handleError(error)
    );
  }

  /**
   * Derive the display-only date/time columns the API doesn't return.
   * Shared by getData() and onPrint() so re-fetched print rows carry the same
   * formatted values the table shows, instead of empty date cells.
   */
  private decorateRows(rows: any[]) {
    rows.forEach(element => {
      if (element?.field_date_and_time) {
        element.field_date_and_time_value = this.reportDateService.formatDate(element.field_date_and_time);
        element.field_date_and_time_1 = this.reportDateService.formatTime(element.field_date_and_time);
      }

      if (element?.field_date_and_time && element?.field_duration) {
        element.field_expiration_date_1 = this.reportDateService.formatTimeAfterDuration(element.field_date_and_time, element.field_duration);
        element.views_conditional_field_1 = this.reportDateService.formatDateAfterDuration(element.field_date_and_time, element.field_duration);
      }

      if (element?.created) {
        element.created_display = this.reportDateService.formatDate(element.created * 1000);
      }
    });
  }

  /**
   * Translate the raw form/route params into the query the backend expects
   * (instructor/entity-type defaults, the tri-state enrollment filter, sorting).
   * Shared by getData() and onPrint() so the printed report is guaranteed to
   * reflect the same filters as the on-screen table.
   */
  private buildRequestParams(params: { parameter: string; value: string; }[]) {
    let finalParams = [...params];

    // Ensure default parameters are always included in finalParams
    let hasInstructor = finalParams.some(p => p.parameter === 'instructor');
    let hasTypeEventEntityType = finalParams.some(p => p.parameter === 'type_event_entity_type');

    if (!hasInstructor) {
      finalParams.push({ parameter: 'instructor', value: '' });
    }

    if (!hasTypeEventEntityType) {
      finalParams.push({ parameter: 'type_event_entity_type', value: 'All' });
    }

    // Also ensure these default parameters are in queryParams for future reference, but only if they don't exist
    if (!this.queryParams.some(p => p.parameter === 'instructor')) {
      this.queryParams.push({ parameter: 'instructor', value: '' });
    }

    if (!this.queryParams.some(p => p.parameter === 'type_event_entity_type')) {
      this.queryParams.push({ parameter: 'type_event_entity_type', value: 'All' });
    }

    // Update the id_op_enrollment parameter based on enrollmentFilter state
    // Must update BOTH queryParams (for export) and finalParams (for API call)
    const enrollmentParamIndex = this.queryParams.findIndex(p => p.parameter === 'id_op_enrollment');
    const finalEnrollmentParamIndex = finalParams.findIndex(p => p.parameter === 'id_op_enrollment');
    if (this.enrollmentFilter === true) {
      this.updateQueryParam(enrollmentParamIndex, 'empty', this.queryParams);
      this.updateQueryParam(finalEnrollmentParamIndex, 'empty', finalParams);
    } else if (this.enrollmentFilter === false) {
      this.updateQueryParam(enrollmentParamIndex, 'not+empty', this.queryParams);
      this.updateQueryParam(finalEnrollmentParamIndex, 'not+empty', finalParams);
    } else {
      // Remove the parameter for the undefined state
      if (enrollmentParamIndex !== -1) {
        this.queryParams.splice(enrollmentParamIndex, 1);
      }
      if (finalEnrollmentParamIndex !== -1) {
        finalParams.splice(finalEnrollmentParamIndex, 1);
      }
    }

    // Add sorting parameters if available
    if (this.sortParams !== undefined) {
      finalParams.push(this.sortParams);
    }

    return finalParams;
  }

  onEnrollmentFilterChange() {
    // Update the enrollment filter state
    if (this.enrollmentFilter === null) {
      this.enrollmentFilter = true;
    } else if (this.enrollmentFilter === true) {
      this.enrollmentFilter = false;
    } else {
      this.enrollmentFilter = null;
    }

    // Reset pagination when filter changes
    this.paginationIndex = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    // Get data with updated filter and reset pagination
    const paginationParams = [
      { parameter: 'page', value: '0' },
      { parameter: 'items_per_page', value: this.pageSize.toString() }
    ];

    // Filter out any existing pagination params
    const filteredQueryParams = this.queryParams.filter(param =>
      param.parameter !== 'page' && param.parameter !== 'items_per_page'
    );

    // Ensure default parameters are included
    let hasInstructor = filteredQueryParams.some(p => p.parameter === 'instructor');
    let hasTypeEventEntityType = filteredQueryParams.some(p => p.parameter === 'type_event_entity_type');

    if (!hasInstructor) {
      filteredQueryParams.push({ parameter: 'instructor', value: '' });
    }

    if (!hasTypeEventEntityType) {
      filteredQueryParams.push({ parameter: 'type_event_entity_type', value: 'All' });
    }

    // Combine and get data
    this.getData([...filteredQueryParams, ...paginationParams]);
  }

  override resetForm() {
    // Clear all stored params
    this.queryParams = [];
    this.sortParams = undefined;

    // Reset enrollment filter
    this.enrollmentFilter = null;

    // Reset pagination
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginationIndex = 0;  // Reset the pagination index
      this.pageSize = 10;  // Reset page size
    }

    // Clear the form
    this.form.resetForm();

    // Clear any autocomplete options
    this.autoCompleteStudentContactOptions = [];

    // Make a fresh request with explicitly empty params plus the required default params
    this.getData([
      { parameter: 'page', value: '0' },
      { parameter: 'items_per_page', value: '10' },
      { parameter: 'type_event_entity_type', value: 'All' },
      { parameter: 'instructor', value: '' }
    ]);

    // Update router last
    this.updateRouterParams({});
  }

  override pageChanged(event: any) {
    LoggerService.log('Custom pageChanged called...');

    // Update pagination state
    this.paginationIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    // Always include pagination parameters
    const paginationParams: any[] = [
      { parameter: 'page', value: this.paginationIndex.toString() },
      { parameter: 'items_per_page', value: this.pageSize.toString() }
    ];

    // Filter out any existing pagination params from queryParams
    const filteredQueryParams = this.queryParams.filter(param =>
      param.parameter !== 'page' && param.parameter !== 'items_per_page'
    );

    // Ensure default parameters are included
    let hasInstructor = filteredQueryParams.some(p => p.parameter === 'instructor');
    let hasTypeEventEntityType = filteredQueryParams.some(p => p.parameter === 'type_event_entity_type');

    if (!hasInstructor) {
      filteredQueryParams.push({ parameter: 'instructor', value: '' });
    }

    if (!hasTypeEventEntityType) {
      filteredQueryParams.push({ parameter: 'type_event_entity_type', value: 'All' });
    }

    // Combine filtered query params with new pagination params and call getData directly
    const combinedParams = [...filteredQueryParams, ...paginationParams];
    this.getData(combinedParams);
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');

    // Check if paginator exists before accessing its properties
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }

    // DO NOT call updateRouterParams here - this prevents duplicate requests
    // The routing has already been handled by pageChanged() or other methods
    LoggerService.log('setupPagination called - skipping route update to prevent duplicates');
  }

  override onPageSizeOptions() {
    return [10, 25, 50, 100, 250];
  }

  /**
   * Override print to use PrintService for proper print formatting.
   *
   * The on-screen table is server-paged (10 rows by default), so printing from
   * dataSource would only ever emit the current page while the heading claims to
   * be the whole appointment list. Re-fetch with a single large page instead, so
   * the printout covers every row the filters matched.
   *
   * Deliberately NOT items_per_page=0 (the backend's no-range escape hatch the
   * CSV export uses): AppointmentListController skips range() entirely for 0,
   * and against this endpoint's event table (millions of rows) that query
   * exhausts PHP mid-response and resolves as a 200 with an empty body.
   *
   * Unlike payments-made-encompassing (where the 5000 cap sits above any real
   * print and never fires), this report has no cap that can print a wide range
   * whole: one week of lessons measures ~17k rows, one month ~72k. So the cap's
   * job here is only to bound the request; the truncation warning below is the
   * real answer for wide ranges. 1000 is chosen for latency, not completeness:
   * measured against this endpoint, 1000 rows returns in ~2s but 5000 takes
   * ~45s (per-row loading degrades sharply past ~2000), and a 45s wait behind a
   * button with no feedback reads as a hang and invites repeat clicks. 1000
   * rows is already ~20 printed pages.
   */
  private static readonly PRINT_ROW_LIMIT = 1000;

  override onPrint() {
    // Must happen here, in the click handler: the fetch below ends the user
    // gesture, so opening the window from its callback trips the popup blocker.
    const printWindow = this._printService.openPrintWindow();
    if (!printWindow) {
      this._snackBar.open(
        'Your browser blocked the print window. Allow pop-ups for this site and try again.',
        'Close', { duration: 8000 });
      return;
    }

    this.ShowProgressBar = true;

    const limit = LessonsListReportComponent.PRINT_ROW_LIMIT;
    const params = this.buildRequestParams([
      ...this.queryParams,
      { parameter: 'page', value: '0' },
      { parameter: 'items_per_page', value: limit.toString() },
    ]);

    this._utilityService.getLessonListReport(params)
      .subscribe((data) => {
        this.ShowProgressBar = false;

        // A dead PHP worker surfaces as a 200 with an empty body, which would
        // otherwise be indistinguishable from a genuinely empty result set.
        if (!data || data['results'] === undefined) {
          printWindow.close();
          this._snackBar.open(
            'Could not build the printout. The report did not return. Try a narrower date range.',
            'Close', { duration: 8000 });
          return;
        }

        const rows = data['results'] || [];
        if (!rows.length) {
          printWindow.close();
          this._snackBar.open('No lessons found for the selected criteria.', 'Close', { duration: 5000 });
          return;
        }

        const total = Number(data['count'] ?? rows.length);
        if (total > rows.length) {
          this._snackBar.open(
            `This range matches ${total} lessons; printing the first ${rows.length}. Narrow the date range to print the rest.`,
            'Close', { duration: 8000 });
        }

        // The date/time columns are client-derived, so decorate before rendering.
        this.decorateRows(rows);
        this.renderPrintout(rows, printWindow);
      },
        error => {
          this.ShowProgressBar = false;
          printWindow.close();
          this.handleError(error);
        }
      );
  }

  /**
   * Build and hand off the printable HTML for an already-fetched result set.
   */
  private renderPrintout(printRows: any[], printWindow: Window | null) {
    const rows = printRows.map((row: any) => `
      <tr>
        <td>${this.escapeHtml(row.id)}</td>
        <td>${this.escapeHtml(row.field_status ?? 'Pending Status')}</td>
        <td>${this.escapeHtml(row.nothing_1)}</td>
        <td>${this.escapeHtml(row.field_first_name)} ${this.escapeHtml(row.field_last_name)}</td>
        <td>${this.escapeHtml(row.views_conditional_field)}</td>
        <td>${this.escapeHtml(row.title_1)}</td>
        <td>${this.escapeHtml(row.field_email)}</td>
        <td>${this.escapeHtml(row.field_date_and_time_value)}</td>
        <td>${this.escapeHtml(row.views_conditional_field_1)}</td>
        <td>${this.escapeHtml(row.field_date_and_time_1)}</td>
        <td>${this.escapeHtml(row.field_expiration_date_1)}</td>
        <td>${this.escapeHtml(row.field_duration)}</td>
        <td>${this.escapeHtml(row.field_type)}</td>
      </tr>
    `).join('');

    const content = `
      <h1 class="report-title">Appointment List</h1>
      <table class="report-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Status</th>
            <th>Enrollment ID</th>
            <th>Instructor</th>
            <th>Event Type</th>
            <th>Attendee(s)</th>
            <th>Student Email</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Duration</th>
            <th>Lesson Type</th>
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>
    `;

    const styles = `
      .report-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 9px;
      }
      .report-table th,
      .report-table td {
        border: 1px solid #ddd;
        padding: 4px 6px;
        text-align: left;
      }
      .report-table th {
        background-color: #f2f2f2;
        font-weight: bold;
      }
      .report-table tr:nth-child(even) {
        background-color: #f9f9f9;
      }
      @page {
        size: landscape;
      }
    `;

    this._printService.print(content, {
      title: 'Appointment List',
      styles: styles,
      showSchoolName: true
    }, printWindow);
  }

  private escapeHtml(value: string | number | null | undefined): string {
    if (value === null || value === undefined) { return ''; }
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}
